import { Component, EventEmitter, Input, Output, input } from '@angular/core';
import { VgApiService } from '@videogular/ngx-videogular/core';
import { CommonService } from '../../../services/common.service';
import { MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

// export interface ChapterModel {
//   startTime: number;
//   endTime: number;
//   width:number
// }

@Component({
  selector: 'app-small-video-player',
  templateUrl: './small-video-player.component.html',
  styleUrl: './small-video-player.component.scss',
})
export class SmallVideoPlayerComponent {
  constructor(
    public commonservice: CommonService,
    public messageService: MessageService
  ) {}

  show_controls = false;

  video_url: any;
  api: any;

  @Input()
  id: any;

  @Input()
  video_data: any;

  @Input()
  thumbnail_url = '';

  @Input()
  sprite_from_db = true;

  @Input()
  required_additional_options = false;

  video_data_segment: any;

  is_loaded_metadata = false;
  duration: any = '00:10:10';
  moment_start_time: any;
  poster_image = '';
  @Output() video_duration: any = new EventEmitter();
  videolibrary=false;

  @Input()
  video_name='';

  ngOnInit() {
    if (this.video_data.path) {
      this.video_url = this.get_cdn(this.video_data.path);
      this.video_data_segment = this.video_data.segment;   
      this.videolibrary =false;
      this.poster_image = encodeURI(this.video_url + '#t=' + this.video_data_segment.start_time_seconds);
    } else {
      this.video_url = this.video_data;
      this.video_data_segment = undefined;
      this.videolibrary = true;
      this.poster_image = encodeURI(this.video_url + '#t=10');
    }
  }

  loaded = false;

  onPlayerReady(api: VgApiService) {
    this.api = api;
    // this.api
    //   .getDefaultMedia()
    //   .subscriptions.loadedData.subscribe((event: any) => {
    //     this.loaded = true;
    //   });
    this.api
      .getDefaultMedia()
      .subscriptions.loadedMetadata.subscribe((event: any) => {
        this.loaded = true;
        this.video_duration.emit(
          {name: this.video_name, duration: this.calculateTime(this.api.getDefaultMedia().duration * 1000)}
        );
        if (this.required_additional_options) {
          let generated_chapters: any = [
            {
              startTime: Number(0) * 1000,
              endTime:
                Number(this.video_data_segment.start_time_seconds) * 1000,
              width: 25,
            },
            {
              startTime:
                Number(this.video_data_segment.start_time_seconds) * 1000,
              endTime: Number(this.video_data_segment.end_time_seconds) * 1000,
              width: 50,
            },
            {
              startTime:
                Number(this.video_data_segment.end_time_seconds) * 1000,
              endTime: Number(this.api.getDefaultMedia().duration) * 1000,
              width: 25,
            },
          ];

          for (let chapter of generated_chapters) {
            chapter.width = this.calculateChapterWidth(chapter);
          }
          this.chapters = generated_chapters;
          this.duration = this.calculateTime(
            this.api.getDefaultMedia().duration * 1000
          );
        }
        if (this.video_data_segment) {
          this.is_loaded_metadata = true;
          this.api.getDefaultMedia().currentTime =
            this.video_data_segment.start_time_seconds;
          this.moment_start_time = this.calculateTime(
            this.video_data_segment.start_time_seconds * 1000
          );
        }
        //this.loaded = true;
      });
    this.api.getDefaultMedia().volume = 0;
  }

  playVideo() {
    this.api.play();
  }

  // this is for chapters thingy
  hoveredPosition: any;
  hoveredTimeInSeconds: any;
  hoveredTime: any;
  hoveredChapterIndex: any;

  updateHoveredTime(event: MouseEvent): void {
    let progressBar = event.currentTarget as HTMLElement;
    let progressBarRect = progressBar.getBoundingClientRect();
    let offsetX = event.clientX - progressBarRect.left;
    let progressBarWidth = progressBarRect.width;
    let percentageHovered = offsetX / progressBarWidth;
    this.hoveredPosition = offsetX;
    let totalTime = this.api ? this.api.getDefaultMedia().duration : 0;
    if (totalTime !== 0) {
      let hoveredTimeInSeconds = percentageHovered * totalTime;
      this.hoveredTimeInSeconds = Math.floor(hoveredTimeInSeconds);
      this.hoveredTime = this.calculateTime(hoveredTimeInSeconds * 1000);
    }
  }

  /**
   * This method converts time in seconds to HH:MM format.
   * @param seconds accepts a time value in seconds
   * @returns the equivalent time in HH:MM format.
   */
  calculateTime(milliseconds: number): string {
    let seconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    seconds %= 60;
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  /**
   * Handle the hover event for a chapter.
   * @param index The index of the hovered chapter.
   */
  chapterHover(index: number): void {
    this.hoveredChapterIndex = index;
  }

  /**
   * Handle the leave event for a chapter.
   *
   * */
  chapterLeave(): void {
    this.hoveredChapterIndex = null;
  }

  /**
   * Seek to the specified chapter label by setting the media's current time.
   * @param event type of mouse event to detect the mouse position
   * @param label The label of the chapter to seek to.
   */
  seekToChapter(event: MouseEvent, chapter: any): void {
    this.api.getDefaultMedia().currentTime = this.hoveredTimeInSeconds;
  }

  /**
   * Get the background color for a chapter based on its start time and the current media time.
   * @param startTime The start time of the chapter.
   * @returns The background color string.
   */
  getChapterColor(startTime: number): string {
    const defaultMedia =
      this.api && this.api.getDefaultMedia ? this.api.getDefaultMedia() : null;
    const currentTime = defaultMedia ? defaultMedia.currentTime : 0;
    return currentTime >= startTime ? 'solid' : '';
  }

  /**
   * Calculate the left position of the chapter container relative to the seekbar container
   * Ensure that the chapter container does not go beyond the left edge of the seekbar container
   * Calculate the left position as a percentage relative to the seekbar width
   * @param offsetX of hoevered part of seekbar
   * @returns left position of container in percentage
   */
  calculateChapterContainerLeft(offsetX: number): string {
    const chapterContainerLeft = offsetX - 160 / 2;
    const minLeftPosition = 0;
    const maxLeftPosition = window.innerWidth - 170;
    const leftPosition = Math.max(
      Math.min(maxLeftPosition, chapterContainerLeft),
      minLeftPosition
    );
    return leftPosition + 'px';
  }

  capturedFrames: { [time: number]: string } = {};
  chapters: any;

  /**
   * Method to get the captured frame at a specific time
   * @param time for which frame needs to be captured
   * @returns thumbnail frame in data format at that time
   */
  getCapturedFrame(time: number): string {
    let roundedTime = time;
    if (!roundedTime || roundedTime == undefined || roundedTime < 0) {
      roundedTime = 0;
    }

    if (roundedTime in this.capturedFrames) {
      // return this.capturedFrames[roundedTime][roundedTime];
      return this.capturedFrames[roundedTime];
    }
    return '';
  }

  generateVideoThumbnailEvent(capturedFrames: any) {
    this.capturedFrames = capturedFrames;
  }

  calculateChapterWidth(chapter: any): number {
    const totalDuration = this.api.getDefaultMedia().duration;
    const chapterStartTime = chapter.startTime / 1000; // Convert milliseconds to seconds
    const chapterEndTime = chapter.endTime / 1000; // Convert milliseconds to seconds
    const chapterDuration = chapterEndTime - chapterStartTime;
    const widthPercentage = Math.round((chapterDuration / totalDuration) * 100);
    return widthPercentage;
  }

  async download(video_data: any) {
    if (
      this.commonservice.downloading[this.id] &&
      this.commonservice.downloading[this.id].value == true
    ) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Please wait while download is in progress',
      });
    } else {
      if (!this.commonservice.downloading[this.id]) {
        this.commonservice.downloading[this.id] = new BehaviorSubject(true);
      } else {
        this.commonservice.downloading[this.id].next(true);
      }

      let body = {
        asset_id: video_data.uuid,
        start_time: video_data.segment.start_time_seconds,
        end_time: video_data.segment.end_time_seconds,
      };

      const res = await this.commonservice.download_trimmed_video(
        video_data.name,
        body,
        this.id
      );

      if (res && res === false) {
        this.commonservice.downloading[this.id].next(false);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Unable to trim the video. Please try again',
        });
      }
    }
  }

  play_video() {
    if (this.required_additional_options == false)
      this.api.getDefaultMedia().play();
  }

  pause_video() {
    if (this.required_additional_options == false)
      this.api.getDefaultMedia().pause();
  }

  get_cdn(url: string) {
    let current_url = `${this.commonservice.apiCallService.Storage_CDN}/${url}`;
    return current_url;
  }

  get_start_time() {
    if (this.video_data_segment?.start_time_seconds)
      return this.video_data_segment?.start_time_seconds;
    else return 0;
  }

  get_end_time() {
    if (this.video_data_segment?.end_time_seconds)
      return this.video_data_segment?.end_time_seconds;
    return this.api?.getDefaultMedia().duration;
  }

  get_small_player_sprite_sheet() {
    if (this.thumbnail_url != '') {
      return this.get_cdn(this.thumbnail_url);
    }
    return this.get_cdn(this.video_data.sprites.big_player_compressed);
    // return this.get_cdn(this.video_data.sprites.big_player);
  }
}
